<div class="p-4 cursor-pointer transition hover:bg-slate-50">
    <div class="text-4xl">
        {{metric}}
    </div>
    <div class="text-sm">{{text}}<span *ngIf="pluralise">{{metric | plural}}</span></div>
    <div *ngIf="suffixText" class="text-xs text-slate-400">
        {{suffixText}}
    </div>
</div>